//@ts-nocheck
import { Palette, createTheme } from '@mui/material/styles';
import { type ClientRectObject } from '@popperjs/core';

export const theme = createTheme<Palette, Record<string, string>>({
  cssVariables: { colorSchemeSelector: '[data-mode-%s]' },
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: '#185AC2',
          diffs: {
            hover: '#3479e6',
            active: '#1c69e1',
            disabled: 'rgba(24, 90, 194, 0.4)'
          }
        },
        secondary: { main: '#8CADE1' },
        success: { main: '#1EBD8D' },
        error: {
          main: '#BA1A1A',
          diffs: {
            hover: '#E23131',
            active: '#D91E1E'
          }
        },
        text: {
          primary: '#44464F',
          secondary: '#90939B',
          light: '#878787',
          placeholder: '#AEAAAB',
          modalDark: '#18191C',
          modalGray: '#79747E',
          statisticsText: '#79747E',
          cashdeskRowInfo: 'var(-mui-palette-text-modalDark)'
        },
        info: {
          main: '#E3E3E4',
          diffs: {
            hover: '#D2D2D4',
            active: '#C1C1C3'
          }
        },
        fields: {
          borderColorDefault: 'var(--mui-palette-divider)',
          borderColorFocus: 'var(--mui-palette-primary-main)',
          borderColorHover: '#1D1B20',
          borderColorError: 'var(--mui-palette-error-main)',
          borderColorDisable: '#AEAAAB'
        },
        background: {
          default: '#E2EAF7',
          paper: '#fff',
          disabled: 'rgba(24, 90, 194, 0.2)',
          backdrop: 'rgba(20, 20, 35, 0.5)',
          login: 'linear-gradient(226deg, #33D2FF 5.73%, #3D68DE 54.65%, #185AC2 96.75%)',
          calendarRange: '#CFDDF3'
        },
        divider: '#BDC1D2',
        /* --------------------------------- */
        methodSelect: {
          active: '#167E55',
          inactive: 'var(--mui-palette-error-main)'
        },
        methodsList: {
          colorDefault: 'var(--mui-palette-primary-main)',
          colorHover: 'var(--mui-palette-primary-diffs-hover)',
          colorActive: 'var(--mui-palette-primary-diffs-active)',
          backgroundDefault: '#FFFFFF',
          backgroundHover: '#FBFBFB',
          backgroundActive: '#E6E6E6'
        },
        tabs: {
          inactiveBackground: 'var(--mui-palette-background-disabled)',
          inactiveColor: 'var(--mui-palette-primary-diffs-disabled)',
          activeBackground: 'var(--mui-palette-primary-main)',
          activeColor: 'var(--mui-palette-background-paper)'
        },
        widgetTabs: {
          backgroundColorAbleDefault: 'var(--mui-palette-primary-main)',
          backgroundColorAbleHover: 'var(--mui-palette-primary-diffs-hover)',
          backgroundColorAblePressed: 'var(--mui-palette-primary-diffs-active)',
          colorDefault: '#949497',
          borderColorDefault: 'var(--mui-palette-divider)',
          colorHover: '#A3A3A6',
          borderColorHover: '#D5D8E5',
          colorPressed: '#8B8B8C',
          borderColorPressed: '#B7BBCE'
        },
        switch: {
          color: 'var(--mui-palette-background-paper)',
          backgroundOn: 'var(--mui-palette-primary-main)',
          backgroundOnHover: 'var(--mui-palette-primary-diffs-hover)',
          backgroundOnPressed: 'var(--mui-palette-primary-diffs-active)',
          backgroundOff: '#7E7E7E',
          backgroundOffHover: '#959595',
          backgroundOffPressed: '#5F5F5F'
        },
        status: {
          activeBackground: 'rgba(15, 142, 104, 0.2)',
          activeColor: '#0F8E68',
          pendingBackground: 'rgba(68, 70, 79, 0.2)',
          pendingColor: '#44464F',
          declinedBackground: 'rgba(186, 26, 26, 0.2)',
          declinedColor: 'var(--mui-palette-error-main)'
        },
        customScrollbar: {
          track: 'transparent',
          thumb: 'rgba(139, 172, 224, 0.5)'
        },
        customTooltip: {
          tooltipText: 'var(--mui-palette-text-primary)',
          tooltipBorder: 'var(--mui-palette-divider)',
          tooltipBackground: 'var(--mui-palette-background-paper)',
          deleteIconColor: 'var(--mui-palette-text-primary)',
          countText: 'var(--mui-palette-primary-main)',
          countBackground: 'var(--mui-palette-background)'
        },
        modal: {
          closeIcon: '#7E7E7E',
          closeIconHover: '#959595',
          closeIconActive: '#5F5F5F',
          clearInputIcon: 'var(--mui-palette-text-primary)',
          clearInputIconHover: '#63656C',
          clearInputIconActive: '#313238',
          uploadErroeIconPressed: 'var(--mui-palette-error-diffs-hover)'
        },
        pagination: {
          itemActiveText: 'var(--mui-palette-primary-main)',
          itemActiveHoverText: '#0b50be',
          itemActiveBackground: '#d9e2ff',
          itemHoverText: 'var(--mui-palette-primary-main)',
          itemHoverBackground: '#c3d1ff',
          pageSizeBorder: 'var(--mui-palette-primary-main)'
        },
        statistics: {
          green: '#1DBF73',
          red: 'var(--mui-palette-error-main)',
          periodBorder: 'var(--mui-palette-divider)',
          periodActiveText: 'var(--mui-palette-background-paper)',
          info: '#AEAAAB',
          inactiveBar: 'var(--mui-palette-table-backgroundRowHover)',
          generalInfoLabels: 'var(--mui-palette-text-statisticsText)',
          xaxis: '#e9e9e9',
          percents: {
            green: {
              background: 'var(--mui-palette-statistics-green)',
              color: 'var(--mui-palette-background-paper)'
            },
            grey: {
              background: 'var(--mui-palette-statistics-info)',
              color: 'var(--mui-palette-text-primary)'
            },
            red: {
              background: 'var(--mui-palette-statistics-red)',
              color: 'var(--mui-palette-background-paper)'
            }
          },
          lines: {
            atv: {
              day: '#F035F0',
              week: 'var(--mui-palette-statistics-green)'
            },
            artt: {
              day: '#53359E',
              week: '#FF9F0A'
            }
          }
        },
        table: {
          backgroundRowHover: 'rgba(24, 90, 194, 0.12)',
          iconDefault: '#AEAAAB',
          iconDelete: 'var(--mui-palette-error-main)',
          iconDeleteHover: 'var(--mui-palette-error-diffs-hover)',
          iconDeleteActive: 'var(--mui-palette-error-diffs-active)',
          iconHover: '#C9C5C6',
          iconActive: '#858383',
          tableHeaderIconHover: '#9A979E'
        },
        sideNav: {
          background: 'var(--mui-palette-primary-main)',
          color: 'var(--mui-palette-secondary-main)',
          colorHover: '#B2C8EB',
          colorActive: '#CFDDF3',
          colorSelected: 'var(--mui-palette-background-paper)'
        },
        messageParsing: {
          divider: '#E3EBF8',
          selectionsDivider: '#AEAAAB',
          selectionsColors: {
            income: '#F1A54F',
            balance: '#ED6A6E',
            remarks: '#A56AED',
            withdrawal: '#03AA5C',
            any: '#AEAAAB',
            amount: '#F1A54F',
            account: '#009AFA'
          }
        },
        toastify: {
          success: '#0f8e68'
        }
      }
    },
    dark: {
      palette: {
        primary: {
          main: '#4B96E7',
          diffs: {
            hover: '#87B9EF',
            active: '#3F7DC0',
            disabled: 'rgba(75, 150, 231, .4)'
          }
        },
        secondary: { main: 'rgba(75, 150, 231, .4)' },
        success: { main: '#0F8E68' },
        error: {
          main: '#ED7D75',
          diffs: {
            hover: '#F3A8A3',
            active: '#C56862'
          }
        },
        text: {
          primary: 'rgba(255, 255, 255, .94)',
          secondary: '#90939B',
          light: 'rgba(255, 255, 255, .6)',
          placeholder: 'rgba(255, 255, 255, .52)',
          modalDark: 'var(--mui-palette-text-primary)',
          modalGray: 'rgba(255, 255, 255, 0.70)',
          statisticsText: 'var(--mui-palette-text-light)',
          cashdeskRowInfo: 'rgba(255, 255, 255, 0.6)'
        },
        info: {
          main: 'rgba(99, 102, 107, .6)',
          diffs: {
            hover: 'rgba(116, 119, 124, .6)',
            active: 'rgba(82, 85, 91, .6)'
          }
        },
        fields: {
          borderColorDefault: 'rgba(99, 102, 107, 0.6)',
          borderColorFocus: 'var(--mui-palette-primary-main)',
          borderColorHover: 'rgba(255, 255, 255, 0.4)',
          borderColorError: 'var(--mui-palette-error-main)',
          borderColorDisable: 'rgba(255, 255, 255, 0.14)'
        },
        background: {
          default: '#151515',
          paper: '#1C1C1C',
          disabled: 'rgba(75, 150, 231, 0.20)',
          backdrop: 'rgba(0, 0, 0, 0.62)',
          login:
            'linear-gradient(208deg, #313131 -8.96%, #313131 3.87%, #303030 14.32%, #303030 22.73%, #2F2F2F 29.5%, #2E2E2E 34.98%, #2D2D2D 39.54%, #2B2B2B 43.55%, #2A2A2A 47.37%, #282828 51.38%, #272727 55.94%, #252525 61.42%, #242424 68.18%, #222 76.6%, #212121 87.04%, #202020 99.87%);',
          calendarRange: 'var(--mui-palette-primary-diffs-disabled)'
        },
        divider: 'rgba(255, 255, 255, .08)',
        /* --------------------------------- */
        methodSelect: {
          active: '#85ED75',
          inactive: 'var(--mui-palette-error-main)'
        },
        methodsList: {
          colorDefault: 'var(--mui-palette-primary-diffs-hover)',
          colorHover: 'var(--mui-palette-primary-diffs-hover)',
          colorActive: 'var(--mui-palette-primary-diffs-active)',
          backgroundDefault: 'var(--mui-palette-background-paper)',
          backgroundHover: '#18191C',
          backgroundActive: 'var(--mui-palette-background-paper)'
        },
        tabs: {
          inactiveBackground: 'var(--mui-palette-background-disabled)',
          inactiveColor: 'var(--mui-palette-primary-diffs-disabled)',
          activeBackground: 'var(--mui-palette-primary-main)',
          activeColor: '#fff'
        },
        widgetTabs: {
          backgroundColorAbleDefault: 'var(--mui-palette-primary-main)',
          backgroundColorAbleHover: 'var(--mui-palette-primary-diffs-hover)',
          backgroundColorAblePressed: 'var(--mui-palette-primary-diffs-active)',
          colorDefault: 'rgba(255, 255, 255, 0.6)',
          borderColorDefault: 'rgba(207, 221, 243, 0.6)',
          colorHover: 'rgba(255, 255, 255, 0.76)',
          borderColorHover: 'rgba(255, 255, 255, 0.76)',
          colorPressed: 'rgba(255, 255, 255, 0.4)',
          borderColorPressed: 'rgba(255, 255, 255, 0.4)'
        },
        switch: {
          color: '#fff',
          backgroundOn: 'var(--mui-palette-primary-main)',
          backgroundOnHover: 'var(--mui-palette-primary-diffs-hover)',
          backgroundOnPressed: 'var(--mui-palette-primary-diffs-active)',
          backgroundOff: 'rgba(255, 255, 255, 0.6)',
          backgroundOffHover: 'rgba(255, 255, 255, 0.76)',
          backgroundOffPressed: 'rgba(255, 255, 255, 0.4)'
        },
        status: {
          activeBackground: 'rgba(15, 142, 104, 0.20)',
          activeColor: '#0F8E68',
          pendingBackground: 'rgba(68, 70, 79, 0.20)',
          pendingColor: 'rgba(255, 255, 255, .6)',
          declinedBackground: 'rgba(186, 26, 26, 0.20)',
          declinedColor: '#ED7D75'
        },
        customScrollbar: {
          track: 'transparent',
          thumb: 'rgba(139, 172, 224, 0.5)'
        },
        customTooltip: {
          tooltipText: '#fff',
          tooltipBorder: 'rgba(255, 255, 255, 0.08)',
          tooltipBackground: 'var(--mui-palette-background-default)',
          deleteIconColor: 'rgba(255, 255, 255, 0.6)',
          countText: 'var(--mui-palette-primary-main)',
          countBackground: 'var(--mui-palette-background-disabled)'
        },
        modal: {
          closeIcon: 'rgba(255, 255, 255, 0.6)',
          closeIconHover: 'rgba(255, 255, 255, 0.76)',
          closeIconActive: 'rgba(255, 255, 255, 0.4)',
          clearInputIcon: 'rgba(255, 255, 255, 0.6)',
          clearInputIconHover: 'rgba(255, 255, 255, 0.76)',
          clearInputIconActive: 'rgba(255, 255, 255, 0.4)',
          uploadErroeIconPressed: 'var(--mui-palette-error-diffs-active)'
        },
        pagination: {
          itemActiveText: 'var(--mui-palette-primary-main)',
          itemActiveHoverText: '#0b50be',
          itemActiveBackground: 'rgba(63, 125, 192, 0.18)',
          itemHoverBackground: 'rgba(135, 185, 239, 0.14)',
          itemHoverText: 'var(--mui-palette-primary-main)',
          pageSizeBorder: 'var(--mui-palette-primary-main)'
        },
        statistics: {
          green: '#3DD48D',
          red: 'var(--mui-palette-error-main)',
          periodBorder: 'rgba(207, 221, 243, 0.60)',
          periodActiveText: '#fff',
          info: 'rgba(255, 255, 255, 0.6)',
          inactiveBar: 'var(--mui-palette-background-disabled)',
          generalInfoLabels: 'inherit',
          xaxis: 'rgba(255, 255, 255, 0.08)',
          percents: {
            green: {
              background: 'rgba(22, 126, 85, 0.14)',
              color: '#1dbf73'
            },
            grey: {
              background: 'var(--mui-palette-statistics-info)',
              color: 'var(--mui-palette-text-primary)'
            },
            red: {
              background: 'rgba(186, 26, 26, 0.14)',
              color: 'var(--mui-palette-statistics-red)'
            }
          },
          lines: {
            atv: {
              day: '#F035F0',
              week: 'var(--mui-palette-statistics-green)'
            },
            artt: {
              day: '#53359E',
              week: '#FF9F0A'
            }
          }
        },
        table: {
          backgroundRowHover: 'var(--mui-palette-background-default)',
          iconDefault: 'rgba(255, 255, 255, .6)',
          iconDelete: 'var(--mui-palette-error-main)',
          iconDeleteHover: 'var(--mui-palette-error-diffs-hover)',
          iconDeleteActive: 'var(--mui-palette-error-diffs-active)',
          iconHover: 'rgba(255, 255, 255, 0.76)',
          iconActive: 'rgba(255, 255, 255, 0.4)',
          tableHeaderIconHover: '#FFFFFF'
        },
        sideNav: {
          background: 'var(--mui-palette-background-paper)',
          color: 'var(--mui-palette-primary-diffs-disabled)',
          colorHover: 'var(--mui-palette-primary-diffs-hover)',
          colorActive: 'var(--mui-palette-primary-diffs-active)',
          colorSelected: 'var(--mui-palette-primary-main)'
        },
        messageParsing: {
          divider: 'rgba(255, 255, 255, 0.08)',
          selectionsDivider: 'rgba(255, 255, 255, 0.08)',
          selectionsColors: {
            income: '#DC6803',
            balance: '#ED7D75',
            remarks: '#B089E0',
            withdrawal: '#08C26B',
            any: 'rgba(255, 255, 255, 0.4)',
            amount: '#DC6803',
            account: '#B089E0'
          }
        },
        toastify: {
          success: 'var(--mui-palette-primary-main)'
        }
      }
    }
  },
  typography: {
    fontFamily: 'Roboto'
  },
  spacing: 2,
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
        disableRipple: true
      },
      variants: [
        {
          props: { variant: 'contained', color: 'primary' },
          style: {
            backgroundColor: 'var(--mui-palette-primary-main)',
            '&:hover': {
              backgroundColor: 'var(--mui-palette-primary-diffs-hover)'
            },
            '&:active': {
              backgroundColor: 'var(--mui-palette-primary-diffs-active)'
            },
            '& svg': {
              color: '#fff'
            },
            '&.Mui-disabled': {
              color: 'var(--mui-palette-primary-diffs-disabled)',
              backgroundColor: 'var(--mui-palette-background-disabled)',
              '& svg': {
                color: 'var(--mui-palette-primary-diffs-disabled)'
              }
            }
          }
        },
        {
          props: { variant: 'contained', color: 'secondary' },
          style: {
            backgroundColor: 'var(--mui-palette-background-paper)',
            color: 'var(--mui-palette-primary-main)',
            '&:hover': {
              backgroundColor: 'var(--mui-palette-background-paper)',
              color: 'var(--mui-palette-primary-diffs-hover)'
            },
            '&:active': {
              color: 'var(--mui=palette-primry-diffs-active)'
            }
          }
        },
        {
          props: { variant: 'contained', color: 'info' }, //TODO ховеры на текст и иконки
          style: {
            backgroundColor: 'var(--mui-palette-info-main)',
            color: 'var(--mui-palette-text-modalDark)',
            '&:hover': {
              backgroundColor: 'var(--mui-palette-info-diffs-hover)'
            },
            '&:active': {
              backgroundColor: 'var(--mui-palette-info-diffs-active)'
            }
          }
        },
        {
          props: { variant: 'contained', color: 'error' },
          style: {
            color: '#fff',
            '&:hover': {
              backgroundColor: 'var(--mui-palette-error-diffs-hover)'
            },
            '&:active': {
              backgroundColor: 'var(--mui-palette-error-diffs-active)'
            },
            '& svg': {
              color: 'fff'
            }
          }
        },
        {
          props: { variant: 'outlined', color: 'primary' },
          style: {
            borderColor: 'var(--mui-palette-primary-main)',
            '&:hover': {
              borderColor: 'var(--mui-palette-primary-diffs-hover)',
              color: 'var(--mui-palette-primary-diffs-hover)'
            },
            '&:active': {
              borderColor: 'var(--mui-palette-primary-diffs-active)',
              color: 'var(--mui-palette-primary-diffs-active)'
            }
          }
        },
        {
          props: { variant: 'outlined', color: 'info' },
          style: {
            border: '1px solid var(--mui-palette-divider)',
            color: '#949497',
            backgroundColor: 'var(--mui-palette-background-paper)',
            cursor: 'pointer',
            '&:hover': {
              border: '1px solid var(--mui-palette-widgetTabs-borderColorHover)',
              color: 'var(--mui-palette-widgetTabs-colorHover)',
              backgroundColor: 'var(--mui-palette-background-paper)'
            },
            '&:active': {
              border: '1px solid var(--mui-palette-widgetTabs-borderColorPressed)',
              color: 'var(--mui-palette-widgetTabs-colorPressed)',
              backgroundColor: 'var(--mui-palette-background-paper)'
            }
          }
        }
      ],
      styleOverrides: {
        contained: {
          border: '1px solid transparent'
        },
        root: {
          borderRadius: 28,
          textTransform: 'none',
          fontWeight: '500',
          boxShadow: 'none'
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          padding: 12
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: ({ theme }) => ({
          width: 'auto',
          margin: '0 auto',
          minWidth: '0px',
          color: 'var(--mui-palette-secondary-main)'
        })
      }
    },
    MuiListItemText: {
      styleOverrides: {
        secondary: {
          color: '#A4B1EA'
        }
      }
    },
    MuiTooltip: {
      defaultProps: {
        slotProps: {
          popper: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: ({ popper }: { popper: ClientRectObject }) => {
                    return [popper.width * 0.3, 0];
                  }
                }
              }
            ]
          }
        }
      },
      styleOverrides: {
        popperArrow: {},
        tooltipArrow: {
          backgroundColor: 'var(--mui-palette-customTooltip-tooltipBackground)',
          border: '1px solid var(--mui-palette-customTooltip-tooltipBorder)',
          fontFamily: 'Roboto',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: '20px',
          letterSpacing: '0.25px',
          padding: '8px 24px',
          borderRadius: '8px',
          color: 'var(--mui-palette-text-primary)',
          boxShadow: '0px 3.5px 14px 0px rgba(16, 24, 40, 0.20)',
          backdropFilter: 'blur(2px)'
        },
        arrow: {
          color: 'var(--mui-palette-customTooltip-tooltipBackground)',
          '&:before': {
            border: '1px solid var(--mui-palette-customTooltip-tooltipBorder)'
          }
        }
      }
    },
    MuiTable: {
      styleOverrides: {
        root: {}
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '.MuiTableCell-root': {
            minHeight: '56px',
            borderBottom: '1px solid var(--mui-palette-divider)',
            padding: '12px 0',
            background: 'var(--mui-palette-background-paper)',
            color: 'var(--mui-palette-text-primary)',
            fontSize: '16px',
            lineHeight: '32px',
            fontWeight: '600',
            letterSpacing: '0.15px'
          },
          '.MuiTableRow-head': {
            background: 'var(--mui-palette-background-paper)'
          }
        }
      }
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          '.MuiTableRow-root': {
            '&:hover': {
              background: 'var(--mui-palette-table-backgroundRowHover)'
            }
          },
          '.MuiTableCell-root': {
            fontWeight: '400',
            '&:first-child': {
              paddingLeft: '16px'
            },
            '&:last-child': {
              paddingRight: '16px'
            }
          }
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        head: {
          background: 'var(--mui-palette-background-paper)'
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: ({ theme }) => ({
          padding: '10px 0',
          height: '32px',
          fontSize: '16px',
          lineHeight: '20px',
          color: 'var(--mui-palette-text-primary)',
          border: 'none'
        })
      }
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent'
        }
      }
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          minWidth: 24,
          minHeight: 24,
          maxHeight: 24,
          borderRadius: 2,
          margin: '0 .1vw',
          backgroundColor: 'var(--mui-palette-background-paper)',
          color: 'var(--mui-palette-text-primary)',
          '&:hover': {
            backgroundColor: 'var(--mui-palette-pagination-itemHoverBackground)',
            color: 'var(--mui-palette-pagination-itemHoverText)'
          },
          '&.Mui-selected': {
            backgroundColor: 'var(--mui-palette-pagination-itemActiveBackground)',
            color: 'var(--mui-palette-pagination-itemActiveText)',
            '&:hover': {
              backgroundColor: 'var(--mui-palette-pagination-itemHoverBackground)',
              color: 'var(--mui-palette-pagination-itemActiveHoverText)'
            }
          }
        }
      }
    },
    MuiBadge: {
      styleOverrides: {
        badge: {
          minWidth: 10,
          height: 10,
          borderRadius: '50%',
          transform: 'scale(1) translate(2px, -2px)'
        }
      }
    },
    MuiSwitch: {
      defaultProps: {
        focusVisibleClassName: '.Mui-focusVisible',
        disableRipple: true
      },
      styleOverrides: {
        root: {
          width: 42,
          height: 24,
          padding: 0,
          margin: 1,
          '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            color: 'var(--mui-palette-switch-color)',
            '&.Mui-checked': {
              transform: 'translateX(18px)',
              color: 'var(--mui-palette-switch-color)',
              '& + .MuiSwitch-track': {
                backgroundColor: 'var(--mui-palette-switch-backgroundOn)',
                opacity: 1,
                border: 0
              },
              '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5
              }
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
              color: 'var(--mui-palette-switch-backgroundOnHover)',
              border: '6px solid var(--mui-palette-background-paper)'
            },
            '&.Mui-disabled + .MuiSwitch-track': {
              opacity: 0.7
            }
          },
          '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 20,
            height: 20
          },
          '& .MuiSwitch-track': {
            borderRadius: 24 / 2,
            backgroundColor: 'var(--mui-palette-switch-backgroundOff)',
            opacity: 1
          },

          '&:hover': {
            '& .MuiSwitch-switchBase': {
              '&.Mui-checked': {
                '& + .MuiSwitch-track': {
                  backgroundColor: 'var(--mui-palette-switch-backgroundOnHover)'
                }
              },
              '& + .MuiSwitch-track': {
                backgroundColor: 'var(--mui-palette-switch-backgroundOffHover)'
              }
            }
          },
          '&:active': {
            '& .MuiSwitch-switchBase': {
              '&.Mui-checked': {
                '& + .MuiSwitch-track': {
                  backgroundColor: 'var(--mui-palette-switch-backgroundOnPressed)'
                }
              },
              '& + .MuiSwitch-track': {
                backgroundColor: 'var(--mui-palette-switch-backgroundOffPressed)'
              }
            }
          }
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--mui-palette-info-main)'
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          color: 'var(--mui-palette-text-primary)',
          '::placeholder': {
            opacity: 1,
            color: 'var(--mui-palette-text-placeholder)'
          }
        },
        root: {
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--mui-palette-fields-borderColorDefault)'
          },

          '&.Mui-focused': {
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: 'var(--mui-palette-fields-borderColorFocus)'
            }
          },
          '&:hover': {
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: 'var(--mui-palette-fields-borderColorHover)'
            }
          },
          '&:hover.Mui-focused': {
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: 'var(--mui-palette-fields-borderColorFocus)'
            }
          },
          '&.Mui-error': {
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: 'var(--mui-palette-fields-borderColorError)'
            }
          },
          '&.Mui-disabled': {
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: 'var(--mui-palette-fields-borderColorDisable)'
            }
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: 12,
          lineHeight: '16px',
          color: 'var(--mui-palette-text-primary)',
          transform: 'scale(1) translate(14px, -9px)'
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '&.Mui-expanded': {
            '.MuiInputBase-root': {
              borderBottomLeftRadius: '0 !important',
              borderBottomRightRadius: '0 !important'
            }
          }
        },
        listbox: {
          borderTopLeftRadius: '0 !important',
          borderTopRightRadius: '0 !important'
        },
        option: ({ theme }) => ({
          padding: '14px 16px !important',
          color: 'var(--mui-palette-text-primary)',
          fontFamily: 'Roboto',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: '20px',
          letterSpacing: ' 0.25px',
          position: 'relative',
          '&:hover': {
            background: 'rgba(24, 90, 194, 0.08)',
            color: 'var(--mui-palette-text-primary)'
          },
          '&:active': {
            background: 'rgba(24, 90, 194, 0.12)',
            color: 'var(--mui-palette-text-primary)'
          },
          '& .MuiCheckbox-root': {
            padding: '0'
          }
        })
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: 'var(--mui-palette-modal-closeIcon)',
          '&:hover': { color: 'var(--mui-palette-modal-closeIconHover)' },
          '&:active': { color: 'var(--mui-palette-modal-closeIconActive)' },
          '&.Mui-checked': {
            '&:hover': {
              color: 'var(--mui-palette-primary-diffs-hover)'
            },
            '&:active': {
              color: 'var(--mui-palette-primary-diffs-active)'
            }
          }
        }
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: 'var(--mui-palette-error-main)',
          bottom: '-28px',
          left: 'calc(50% - 40px)'
        })
      }
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          background: 'var(--mui-palette-background-backdrop)'
        }
      }
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          '&#menu-method_id': {
            '.MuiPaper-root': {
              maxHeight: '350px'
            }
          },
          '&#menu-currency': {
            '.MuiPaper-root': {
              maxHeight: '350px'
            }
          },
          '&#menu-page-size': {
            '.MuiButtonBase-root.MuiMenuItem-root': {
              '&.Mui-selected': {
                background: 'var(--mui-palette-pagination-itemActiveBackground)',
                color: 'var(--mui-palette-primary-main)',
                '&:hover': {
                  color: 'var(--mui-palette-pagination-itemActiveHoverText)'
                }
              },
              '&:hover': {
                color: 'var(--mui-palette-pagination-itemHoverText)',
                background: 'var(--mui-palette-pagination-itemHoverBackground)'
              }
            }
          },
          '&#menu-methodSelect': {
            '.Mui-selected': {
              background: 'inherit'
            },
            '.MuiPaper-root': {
              maxWidth: '176px',
              maxHeight: '500px',
              marginTop: '10px',
              padding: '0 16px',
              borderRadius: '20px',
              border: '1px solid var(--mui-palette-primary-main)',
              boxSizing: 'border-box'
            },
            '.MuiList-root': {
              padding: '0',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-around'
            },
            '.MuiMenuItem-root': {
              padding: '12px 0 10px',
              borderBottom: '1px solid var(--mui-palette-divider)',
              fontFamily: 'Roboto',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: '500',
              lineHeight: '20px',
              letterSpacing: '0.25px',
              '&:hover': {
                background: 'inherit',
                borderColor: 'var(--mui-palette-primary-main)'
              },
              '&:last-child': {
                borderBottom: 'none'
              }
            }
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          '--Paper-overlay': 'none !important'
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          flexDirection: 'row-reverse',
          justifyContent: 'flex-start',
          gap: '8px',
          padding: '8px 12px',
          '.MuiButtonBase-root': {
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: '500',
            letterSpacing: '0.1px',
            padding: '10px 12px',
            minWidth: '43px',
            margin: '0'
          }
        }
      }
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          background: 'var(--mui-palette-tabs-inactiveBackground)'
        }
      }
    }
  }
});
